module.exports = __webpack_public_path__ + "img/mobile/PromoBetBar/info_prompt@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/PromoBetBar/info_prompt@2x.png
// module id = 200
// module chunks = 0